<template>
  <div class="matchSuccessStyle">
    <p class="title">推荐产品</p>
    <div
      class="matchList"
      v-if='matchList.length>0'
    >
      <product-item
        ref="productItemRef"
        :key="index"
        v-for="(item, index) in matchList"
        :productItemData="item"
      >
      </product-item>
    </div>
    <div
      class="noListImg"
      v-else
    >
      <img
        src="@/assets/images/nodata.png"
        alt=""
      >
      <span>暂无数据</span>
    </div>
    <div class="noMachList">
      <NoMatchList :noMatchList='noMatchList' />
    </div>
  </div>

</template>
<script>
import Loading from '@/components/Loading.vue';
import ProductItem from '@/views/pages/publicPage/loanSupermarket/components/ProductItem.vue';
import NoMatchList from './component/noMatchList.vue';


export default {
  name: 'matchSuccessful',
  data() {
    return {
      matchList: [],
      // matchList: [],
      noMatchList: [],
    };
  },
  mounted() {
    // 获取推荐产品数据列表
    this.getMatchList();
  },
  components: {
    ProductItem,
    NoMatchList,
  },
  methods: {
    getMatchList() {
      console.log('我是获取信息');
      // this.$toast.loading({
      //   message: '加载中...',
      //   clear: true,
      //   forbidClick: true,
      //   duration: 0,
      //   loadingType: 'spinner',
      // });
      const {
        corpName, taxNo, borrowerName, borrowerType,
      } = this.$router.currentRoute.query;
      const context = this;
      this.$api.InteligentMatchPage.queryMatchList({
        corpName,
        taxNo,
        borrowerName,
        borrowerType,
        pageNum: 1,
        pageSize: 500,

      }).then((res) => {
        if (res.success) {
          this.matchList = res.data.list;
        } else {
          this.matchList = [];
        }
        context.getNomatchList(res.data ? res.data.list : []);
      });
    },
    getNomatchList(list) {
      let productIds = [];
      if (list && list.length > 0) {
        productIds = list.map((item) => item.productId);
      }
      this.$api.InteligentMatchPage.queryNoMatchList({
        productIds,
        pageNum: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.success) {
          this.noMatchList = res.data.list;
        } else {
          this.noMatchList = [];
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  padding: 12px 15px;
  margin: 0;
  text-align: left;
  color: #1c2438;
  font-size: 17px;
  font-weight: bold;
}
.noListImg {
  width: 100%;
  height: 280px;
  overflow: hidden;
  margin-top: 30px;
}
.noListImg img {
  width: 100%;
  height: 100%;
}
.noListImg span {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  letter-spacing: 0;
  text-align: center;
  margin-top: -90px;
}
</style>
